<script setup>
import { useAppStore } from '@/stores/App'

// Vars
const app = useAppStore()

// SEO
useSeoMeta({
    title: 'Cookie Policy',
    ogTitle: 'Cookie Policy',
    description: 'satYatunes Cookie Policy',
    ogDescription: 'satYatunes Cookie Policy',
})
</script>

<template>
    <v-row id="cookie" justify="center" align="start" class="mb-16 slide-from-top">
        <v-col cols="12" sm="10" class="mt-4 text-center">
            <!-- <div class="text-h4 font-weight-medium">Cookie Policy</div> -->
            <app-section-header :id="`support`" :title="`Cookie Policy`" :subtitle="``" />
            <div>Last updated: {{ app.lastUpdatedDates.cookiePolicy }}</div>
            <br />
            <div class="text-left">
                This Cookie Policy explains how satYatunes ("Company", "we", "us" or "our"), uses cookie and similar
                technologies to recognize you when you visit our website at https://satyatunes.com ("Websites"). It
                explains what these technoligies are and why we use them, as well as your rights to control our use of
                them. In some cases we may use cookies to collect personal information, or that becomes personal
                information if we combine it with other information.
            </div>
        </v-col>
        <v-col cols="12" sm="10">
            <v-expansion-panels class="mb-10 elevation-0">
                <v-expansion-panel class="elevation-0">
                    <v-expansion-panel-title class="font-weight-bold">WHAT ARE COOKIES? </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        Cookies are small data files that are placed on your computer or mobile device when you visit a
                        website. Cookies are widely used by website owners in order to make their websites work, or to
                        work more efficiently, as well as to provide reporting information. Cookies set by the website
                        owner (in this case, satYatunes) are called "first party cookies". Cookies set by parties other
                        than the website owner are called "third party cookies". Third party cookies enable third party
                        features or functionality to be provided on or through the website (e.g. like advertising,
                        interactive content and analytics). The parties that set these third party cookies can recognize
                        your computer both when it visits the website in question and also when it visits certain other
                        websites.
                    </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel class="elevation-0">
                    <v-expansion-panel-title class="font-weight-bold"> WHY DO WE USE COOKIES? </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        We use first and third party cookies for several reasons. Some cookies are required for
                        technical reasons in order for our Websites to operate, and we refer to these as "essential" or
                        "strictly necessary" cookies. Other cookies also enable us to track and target the interests of
                        our users to enhance the experience on our Online Properties. Third parties serve cookies
                        through our Websites for advertising, analytics and other purposes.
                    </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel class="elevation-0">
                    <v-expansion-panel-title class="font-weight-bold">
                        HOW CAN I CONTROL COOKIES?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        <p>
                            You have the right to decide whether to accept or reject cookies. You can exercise your
                            cookie rights by setting your preferences in the Browser. Essential cookies cannot be
                            rejected as they are strictly necessary to provide you with services.
                        </p>
                        <p>
                            If you choose to reject cookies, you may still use our website though your access to some
                            functionality and areas of our website may be restricted. You may also set or amend your web
                            browser controls to accept or refuse cookies. As the means by which you can refuse cookies
                            through your web browser controls vary from browser-to-browser, you should visit your
                            browser's help menu for more information.
                        </p>
                        <p>
                            In addition, most advertising networks offer you a way to opt out of targeted advertising.
                            If you would like to find out more information, please visit
                            <a
                                href="http://www.aboutads.info/choices/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="about ad choices"
                            >
                                http://www.aboutads.info/choices/
                            </a>
                            or
                            <a
                                href="http://www.youronlinechoices.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="about online choices"
                            >
                                http://www.youronlinechoices.com</a
                            >.
                        </p>
                        <p>
                            The specific types of first and third party cookies served through our Websites are
                            described in the table below (please note that the specific cookies served may vary
                            depending on the specific Online Properties you visit):
                        </p>
                        <ul class="pt-0">
                            <li>
                                <span class="pb-0 font-weight-bold">Essential website cookies:</span> These cookies are
                                strictly necessary to provide you with services available through our Websites and to
                                use some of its features, such as access to secure areas.
                            </li>
                            <li>
                                <span class="pb-0 font-weight-bold">Analytics and customization cookies:</span> These
                                cookies collect information that is used either in aggregate form to help us understand
                                how our Websites are being used or how effective our marketing campaigns are, or to help
                                us customize our Websites for you.
                            </li>
                            <li>
                                <span class="pb-0 font-weight-bold">Advertising cookies:</span> These cookies are used
                                to make advertising messages more relevant to you. They perform functions like
                                preventing the same ad from continuously reappearing, ensuring that ads are properly
                                displayed for advertisers, and in some cases selecting advertisements that are based on
                                your interests.
                            </li>
                            <li>
                                <span class="pb-0 font-weight-bold">Unclassified cookies:</span> These are cookies that
                                have not yet been categorized. We are in the process of classifying these cookies with
                                the help of their providers.
                            </li>
                        </ul>
                    </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel class="elevation-0">
                    <v-expansion-panel-title class="font-weight-bold">
                        WHAT ABOUT OTHER TRACKING TECHNOLOGIES, LIKE WEB BEACONS?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        Cookies are not the only way to recognize or track visitors to a website. We may use other,
                        similar technologies from time to time, like web beacons (sometimes called "tracking pixels" or
                        "clear gifs"). These are tiny graphics files that contain a unique identifier that enable us to
                        recognize when someone has visited our Websites or opened an e-mail including them. This allows
                        us, for example, to monitor the traffic patterns of users from one page within a website to
                        another, to deliver or communicate with cookies, to understand whether you have come to the
                        website from an online advertisement displayed on a third-party website, to improve site
                        performance, and to measure the success of e-mail marketing campaigns. In many instances, these
                        technologies are reliant on cookies to function properly, and so declining cookies will impair
                        their functioning.
                    </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel class="elevation-0">
                    <v-expansion-panel-title class="font-weight-bold">
                        DO YOU USE FLASH COOKIES OR LOCAL SHARED OBJECTS?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        <p>
                            Websites may also use so-called "Flash Cookies" (also known as Local Shared Objects or
                            "LSOs") to, among other things, collect and store information about your use of our
                            services, fraud prevention and for other site operations.
                        </p>
                        <p>
                            If you do not want Flash Cookies stored on your computer, you can adjust the settings of
                            your Flash player to block Flash Cookies storage using the tools contained in the
                            <a
                                href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="about website storage settings panel"
                            >
                                Website StorageSettings Panel
                            </a>
                            . You can also control Flash Cookies by going to the
                            <a
                                href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager03.html"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="about global storage settings panel"
                            >
                                Global Storage Settings Panel
                            </a>
                            and following the instructions (which may include instructions that explain, for example,
                            how to delete existing Flash Cookies (referred to "information" on the Macromedia site), how
                            to prevent Flash LSOs from being placed on your computer without your being asked, and (for
                            Flash Player 8 and later) how to block Flash Cookies that are not being delivered by the
                            operator of the page you are on at the time).
                        </p>
                        <p>
                            Please note that setting the Flash Player to restrict or limit acceptance of Flash Cookies
                            may reduce or impede the functionality of some Flash applications, including, potentially,
                            Flash applications used in connection with our services or online content.
                        </p>
                    </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel class="elevation-0">
                    <v-expansion-panel-title class="font-weight-bold">
                        DO YOU SERVE TARGETED ADVERTISING?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        Third parties may serve cookies on your computer or mobile device to serve advertising through
                        our Websites. These companies may use information about your visits to this and other websites
                        in order to provide relevant advertisements about goods and services that you may be interested
                        in. They may also employ technology that is used to measure the effectiveness of advertisements.
                        This can be accomplished by them using cookies or web beacons to collect information about your
                        visits to this and other sites in order to provide relevant advertisements about goods and
                        services of potential interest to you. The information collected through this process does not
                        enable us or them to identify your name, contact details or other details that directly identify
                        you unless you choose to provide these.
                    </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel class="elevation-0">
                    <v-expansion-panel-title class="font-weight-bold">
                        HOW OFTEN WILL YOU UPDATE THIS COOKIE POLICY?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        We may update this Cookie Policy from time to time in order to reflect, for example, changes to
                        the cookies we use or for other operational, legal or regulatory reasons. Please therefore
                        re-visit this Cookie Policy regularly to stay informed about our use of cookies and related
                        technologies. The date at the top of this Cookie Policy indicates when it was last updated.
                    </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel class="elevation-0">
                    <v-expansion-panel-title class="font-weight-bold">
                        WHERE CAN I GET FURTHER INFORMATION?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        <p>
                            If you have any questions about our use of cookies or other technologies, please email us at
                            satyatunes(at)yahoo(dot)com or by post to:
                        </p>
                        <lazy-company-address-india />
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-col>
    </v-row>
</template>

<style scoped></style>
